import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import ExpandIcon from '../ExpandIcon';

const ListBoxField = ({
  id,
  name,
  value,
  defaultValue,
  disabled,
  onChange,
  className,
  options,
  withCancel,
  onCancel
}) => {
  const divClassNames = classNames('list-box-field', {
    'list-box-field--disabled': disabled
  }, className);

  const selectClassNames = classNames('list-box-field__select', {
    'list-box-field__select--disabled': disabled
  });

  const handleChange = (e) => !disabled && onChange(e.target.value);

  return (
    <div className={divClassNames}>
      {withCancel && (
        <i
          className="list-box-field__cancel material-icon material-icon--cancel"
          onClick={onCancel}
        />
      )}
      <select
        id={id}
        name={name}
        value={value}
        defaultValue={defaultValue}
        disabled={disabled}
        onChange={handleChange}
        className={selectClassNames}
      >
        {options && options.map(item => (
          <option
            value={item.value}
            key={item.value}
            selected={item.selected}
          >
            {item.label}
          </option>
        ))}
      </select>
      <ExpandIcon className="list-box-field__icon" />
    </div>
  );
};

ListBoxField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any,
  defaultValue: PropTypes.any,
  disabled: PropTypes.bool,
  withCancel: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  className: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any.isRequired,
    label: PropTypes.node.isRequired,
    selected: PropTypes.bool
  })).isRequired
};

ListBoxField.defaultProps = {
  withCancel: false,
  onCancel: () => undefined
};

export default ListBoxField;
